import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

export const getFormatedDate = (
  date: string | Date,
  dateFormat?: string
): string => {
  const dateToFormat = typeof date === 'string' ? new Date(date) : date;
  return format(dateToFormat, dateFormat || 'dd MMM yyyy HH:mm', {
    locale: ru,
  });
};

export function isPasswordStrong(password: string) {
  return /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(password);
}
